import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    '@global': {
      '.MuiPickersBasePicker-pickerView': {
        maxWidth: '100% !important',
      },
    },
    root: {
      display: 'flex',
    },
    paperRoot: {
      marginTop: 32,
      paddingBottom: theme.spacing(2),
    },
    paperTitle: {
      color: theme.palette.primary.main,
    },
    gridContainer: {
      padding: '0px 16px',
    },
    customChip: {
      display: 'flex',
      alignItems: 'center',
      background: theme.palette.colors.blue,
      height: 32,
      borderRadius: theme.spacing(2),
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
    customChipText: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      paddingLeft: 12,
      paddingRight: 12,
      textOverflow: 'ellipsis',
      fontWeight: 550,
      color: theme.palette.colors.white,
    },
    customChipInput: {
      marginTop: 9,
      '& .MuiInput-formControl': {
        display: 'none',
      },
      '& .MuiChip-clickable.MuiChip-deletable': {
        height: 28,
        backgroundColor: `${theme.palette.colors.blue} !important`,
        color: theme.palette.colors.white,
        border: `0.5px solid ${theme.palette.colors.green}`,

        '& .MuiChip-label': {
          fontWeight: 550,
        },
        '& svg path': {
          color: theme.palette.colors.white,
        },
      },
    },
    chipContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: theme.spacing(2),
      paddingTop: 0,
    },
    chip: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,

      '& svg path': {
        color: theme.palette.colors.white,
      },
    },
    icons: {
      display: 'flex',
      alignItems: 'center',
    },
    chipFilter: {
      paddingLeft: theme.spacing(2),
    },
    chipLabel: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.colors.blue,
    },
    chipRoot: {
      minWidth: 150,
      justifyContent: 'space-between',
    },
    chipAdd: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A !important',
      '& span': {
        color: '#14171A',
      },
      cursor: 'pointer',
    },
    deleteIcon: {
      width: 16,
      height: 16,
      background: ' #14171A',
      color: '#fff',
      borderRadius: '50%',

      '&:hover': {
        color: '#fff',
      },
    },
    addButton: {
      background: '#0094FF',
      borderRadius: 12,
      color: '#fff',
      minHeight: 40,
      padding: '0px 16px',
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
  }),
);

export default useStyles;
